import {Grid} from '@material-ui/core';
import React, {useState} from 'react';
import BalancesLocationCard from '../../Patients/Patientdetails/BalancesLocationCard/BalancesLocationCard';
import {useSelector} from 'react-redux';
import CurrentStatementsCard from '../../Patients/Patientdetails/CurrentStatementsCard/CurrentStatementsCard';
import PreviousStatementsCard from '../../Patients/Patientdetails/PreviousStatementCard/PreviousStatementCard';
import NotificationHistoryCard from '../../Patients/Patientdetails/NotificationHistoryCard/NotificationHistoryCard';
import PatientActivityCard from '../../Patients/Patientdetails/PatientActivityCard/PatientActivityCard';

const StatementsContainer = (): JSX.Element => {
  // FIXME: ADD PROPER TYPES
  const selectedPatient = useSelector(
    (state: any) => state.patientDetailsDrawer.patientDetails
  );

  const patientDetailsDrawer = useSelector(
    (state: any) => state.patientDetailsDrawer
  );

  const [forceUpdate, setForceUpdate] = useState(1);

  const [updateStatements, setUpdateStatements] = useState(1);

  return (
    <Grid
      container
      spacing={3}
      key={updateStatements}
      // className={classes.DetailsView}
    >
      <Grid item xs={12} md={6}>
        <BalancesLocationCard
          guarantorId={selectedPatient?.guarantor_id}
          clinicId={patientDetailsDrawer?.clinicId}
          // ADDED TO UPDATE COMPONENT AFTER TAKE PAYMENT COMPLETED
          key={forceUpdate}
          resetPagesInGrid={() => {
            setForceUpdate(forceUpdate + 1);
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <CurrentStatementsCard
          clinicId={patientDetailsDrawer?.clinicId}
          invoiceId={selectedPatient?.invoice_id}
          guarantorId={selectedPatient?.guarantor_id}
          patientId={selectedPatient?.patient_id}
          patient={selectedPatient}
          refreshStatementsTab={() => {
            setUpdateStatements(p => p + 1);
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PreviousStatementsCard
          clinicId={patientDetailsDrawer?.clinicId}
          patientId={selectedPatient?.patient_id}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <NotificationHistoryCard
          guarantorId={selectedPatient?.guarantor_id}
          clinicId={patientDetailsDrawer?.clinicId}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <PatientActivityCard
          guarantorId={selectedPatient?.guarantor_id}
          clinicId={patientDetailsDrawer?.clinicId}
        />
      </Grid>
    </Grid>
  );
};

export default StatementsContainer;
